import { useEffect, useRef, useState } from "react";
import InputComponent from "../elements/InputComponent";
import ButtonComponent from "../elements/ButtonComponent";
import { axiosPrivate } from "../../api/axios";
import { Controller } from "react-hook-form";
import { LOGIN_URL, FORGET_PASSWORD_URL } from "../../api/apiClient";
const EnterPhoneNumber = ({
  handleSubmit,
  control,
  errors,
  onEnterPhone,
  goToLogin,
  closeModal,
  setOtp_ticket,
  isForgetPassword,
}: any) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const modalContentRef = useRef<HTMLDivElement>(null);

  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const enterPhoneNumber = async (formData: any) => {
    try {
      setIsButtonDisabled(true);
      if (isForgetPassword) {
        if (errors?.forget_phone_number) return;
        const { forget_phone_number } = formData;
        var data = JSON.stringify({ phone_number: forget_phone_number });
      } else {
        if (errors?.phone_number) return;
        const { phone_number } = formData;
        var data = JSON.stringify({ phone_number });
      }

      localStorage.setItem("phone_number", formData?.forget_phone_number);
      const response = await axiosPrivate.post(
        isForgetPassword ? FORGET_PASSWORD_URL : LOGIN_URL,
        data,
        {}
      );

      setOtp_ticket(response?.data?.data.otp_ticket);

      onEnterPhone();
    } catch (error) {
      if ((error as any)?.response) {
      } else {
        console.error("Error or no response:", error);
      }
    } finally {
      setIsButtonDisabled(false);
    }
  };

  return (
    <>
      <div className=" flex items-end justify-start rounded-t pl-3 pt-2">
        <button
          type="button"
          onClick={closeModal}
          className="text-gray-700 bg-transparent rounded-lg w-8 h-8 ms-auto inline-flex justify-end items-center  "
        >
          <svg
            className="w-3 h-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
          <span className="sr-only">Close modal</span>
        </button>
      </div>
      <div className="mx-8">
        <form onSubmit={handleSubmit(enterPhoneNumber)} className="w-full">
          <div
            ref={modalContentRef}
            className=" max-h-[356px] flex flex-col gap-6"
          >
            <div className="flex flex-col items-center justify-center gap-8">
              <img
                src="/icons/LogoNamePlusFinger.svg"
                className="w-[113px] h-[36px]"
                alt="logo vam30"
              />
            </div>
            {isForgetPassword ? (
              <label className="text-Title/20/Bold">فراموشی رمز عبور</label>
            ) : (
              <label className="text-Title/20/Bold">ورود یا ثبت نام</label>
            )}

            <Controller
              name={isForgetPassword ? "forget_phone_number" : "phone_number"}
              control={control}
              render={({ field }) => (
                <InputComponent
                  {...field}
                  inputName="phonenumber"
                  maxLength={11}
                  label="شماره موبایل"
                  type="tel"
                  size="regular"
                  errors={
                    isForgetPassword
                      ? errors?.forget_phone_number
                      : errors?.phone_number
                  }
                  control={control}
                  svgIcon={
                    <img
                      src="/icons/phone-outline.svg"
                      alt="lastName icon"
                      width={16}
                    />
                  }
                  inputRef={(el: any) => {
                    inputRef.current = el;
                    if (el) el.focus();
                  }}
                />
              )}
            />
          </div>

          <div className="flex flex-col items-center gap-3 pb-6 ">
            {isForgetPassword ? (
              <ButtonComponent
                isClicked={isButtonDisabled}
                disabled={isButtonDisabled}
                type="submit"
                className="w-full h-[40px] mt-4"
              >
                دریافت کد تایید
              </ButtonComponent>
            ) : (
              <ButtonComponent
                isClicked={isButtonDisabled}
                disabled={isButtonDisabled}
                type="submit"
                className="w-full h-[40px]"
              >
                ورود با پیامک (ثبت نام)
              </ButtonComponent>
            )}

            {!isForgetPassword && (
              <ButtonComponent
                type="button"
                className="w-full h-[40px]"
                onClick={() => goToLogin()}
                bgColor="bg-white"
                textColor="text-primary-600"
                variant="text"
              >
                ورود با رمز عبور
              </ButtonComponent>
            )}
          </div>
        </form>
      </div>
    </>
  );
};

export default EnterPhoneNumber;
